export const slugify = (text) => {
  return String(text || "")
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9\s-]/g, " ")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const buildItemUrl = (itemLike) => {
  const itemId = itemLike?.item_id ?? itemLike?.id;
  if (itemId == null || itemId === "") return "/item";
  const slug = slugify(itemLike?.name);
  return slug ? `/item/${itemId}/${slug}` : `/item/${itemId}`;
};
